import React, { Component } from 'react'
import { ReactSVG } from 'react-svg'
import { BnSubpage } from '../Page'
import { Keyboard } from '../Keyboard'
import { BnLabel1, BnLabel2 } from '../Label'
import { BnButton, BnBackButton } from '../Button'
import IOSSettings from '../../assets/Icons/iOSSettings.png'
import IOSKeyboards from '../../assets/Icons/iOSKeyboards.png'
import IOSGeneralSettings from '../../assets/Icons/iOSGeneralSettings.png'
import IntelliKeyLogo2D from '../../assets/Icons/IntelliKeyAppIcon.svg'
import MacSettings from '../../assets/Icons/MacSettings.png'
import IntelliKeySmall from '../../assets/Icons/IntelliKeySml.svg'
import BackgroundActivity from '../../assets/Icons/Signin.svg'

import Enable from '../../assets/Icons/Enable.png'
import Done from '../../assets/Icons/Done.svg'
import './index.css'
import { GetStarted } from '../KeyboardLogin'
import {
  MAC_SETUP_TASK_KEYS,
  completedMacSetupTaskCount,
  shouldShowMacSetupTaskAction
} from '../../classes/MacSetupStatus.js'

const privacyBlurb = <p>*About Full Access<p/> It is important to note that legitimate third party keyboards require Full Access in order to access their servers.<p/> Keep in mind that apps that handle sensitive data, such as a banking app, do not use third party keyboards. <p/>Additionally, password fields are not accessible to third party keyboards.</p>



const KeyboardStep = props => {
  return <div className='keyboardSettingsStep'>
           <div className='keyboardSettingsStepNumber'>
             {props.stepNumber}
           </div>
           <div className={'keyboardSettingsStepIcon' + (props.className ? ' ' + props.className : '')}>
             { props.icon && <ReactSVG src={props.icon}/>}
             { props.image && <img src={props.image}/>}
           </div>
           <div className='keyboardSettingsStepText'>
             {props.text}
           </div>
           {props.subtext &&
           <div className='keyboardSettingsStepSubtext'>
             {props.subtext}
           </div>}
         </div>
}

const steps = [
  {
    image:IOSSettings,
    text: <span className='settingStepText'>Go to&nbsp;<span className='settingsStepBold'>Settings</span></span>
  },
  {
    image:IntelliKeyLogo2D,
    className: 'appIconImage',
    text: <span className='settingStepText'>Go to&nbsp;<span className='settingsStepBold'>IntelliKey</span></span>
  },
  {
    image:IOSKeyboards,
    text: <span className='settingStepText'>Open&nbsp;<span className='settingsStepBold'>Keyboards</span></span>
  },
  {
    image: Enable,
    text: <span className='settingStepText'>Enable&nbsp;<span className='settingsStepBold'>Keyboard</span></span>
  },
  {
    image: Enable,
    text: <span className='settingStepText'>Enable&nbsp;<span className='settingsStepBold'>Allow Full Accesss</span></span>,
  }
  ]

export class KeyboardSettings extends BnSubpage {

  takeMeThere = () => {
    this.props.me.openKeyboardSettings()    
  }
  renderContent() {
    console.log(this.props)
    const done = this.props.done
    if (done) {
      return <GetStarted className='signInCreateAccount' me={this.props.me} text='Enable IntelliKey Keyboard' icon={Done} label={'Done'} action={this.props.doneClicked}/>
    }
    let title = this.props.done ? "Keyboard is Enabled" : "Enable IntelliKey Keyboard"
    const filteredSteps = steps.filter(x => {
      return this.props.isInstalled ? x.type !== 'installation' : true
    })
    return <div className={'keyboardSettingsContent'  + (done ? ' keyboardSettingsDone' : '')}>
             <div className={'keyboardSettingsTitle'}>
               <BnLabel1 text={title}/>
             </div>
             <div className='keyboardSettingStepsContainer'>
               <div className='keyboardSettingSteps'>
                 {
                   filteredSteps.map((step, i) => {
                     let { text, subtext, className } = step
                     if (i == 1) {
                       text = <div className='keyboardSettingStep2'>
                                {text} <div className='keyboardSettingStep2TakeMeThere' onClick={this.takeMeThere}>Take me there</div>
                              </div>
                     }
                     return <KeyboardStep
                              stepNumber={i + 1}
                              icon={step.icon}
                              image={step.image}
                              text={text}
                              subtext={subtext}
                              className={className}
                            />
                     
                   })
                 }
               </div>
             </div>
             <div className='keyboardSettingsButtonSpacer'/>
             {<BnButton label={'Done'} action={this.props.doneClicked}/>}
             {this.props.isEnabled && !this.props.hasFullAccess &&
              <div className='privacyBlurb' onClick>
                {(true ||this.state.privacyBlurbExpanded) ? privacyBlurb : "About Third-Party Keyboards & Privacy..."}
              </div>}
           </div>
  }
}

const macSetupSteps = [
  {
    key: 'inputMethodInstalled',
    title: 'Install the IntelliKey input method',
    detail: 'IntelliKey installs and verifies its keyboard component automatically.',
    image: IntelliKeyLogo2D,
    action: 'installInputMethod',
    actionLabel: 'Install'
  },
  {
    key: 'inputSourceEnabled',
    title: 'Add IntelliKey to Input Sources',
    detail: 'In Keyboard Settings, go to Text Input and click Edit… Then click +. Select English. Then select IntelliKey, and click Add.',
    image: MacSettings,
    action: 'openKeyboardSettings',
    actionLabel: 'Open Settings',
    actionAlwaysAvailable: true
  },
  {
    key: 'inputSourceSelected',
    title: 'Select IntelliKey',
    detail: 'Open the input menu at the top-right of the menu bar and choose IntelliKey.',
    icon: IntelliKeySmall,
    action: 'refresh',
    actionLabel: 'Check Again'
  },
  {
    key: 'backgroundActivityEnabled',
    title: 'Allow background activity',
    detail: 'In Login Items & Extensions, turn on IntelliKey under App Background Activity.',
    icon: BackgroundActivity,
    action: 'openLoginItemsSettings',
    actionLabel: 'Open Settings'
  },
  {
    key: 'accessibilityEnabled',
    title: 'Allow Accessibility',
    detail: 'Click Allow Access, approve the macOS dialogs, and enable IntelliKey in Accessibility settings. Enter your Mac password or use Touch ID if asked. If this step stays incomplete, use Show App and add that exact copy with +.',
    image: Enable,
    action: 'requestAccessibility',
    actionLabel: 'Allow Access',
    secondaryAction: 'revealApplication',
    secondaryActionLabel: 'Show App'
  }
]

const MacSetupStep = ({ step, number, complete, action, canRevealApplication }) => {
  const runAction = () => action(step.action)
  const showAction = shouldShowMacSetupTaskAction(
    complete,
    step.actionAlwaysAvailable
  )
  return <div className={'macKeyboardSetupStep' + (complete ? ' macKeyboardSetupStepComplete' : '')}>
           <div className='macKeyboardSetupStepState'>
             {complete ? <ReactSVG src={Done}/> : number}
           </div>
           <div className='macKeyboardSetupStepIcon'>
             {step.icon && <ReactSVG src={step.icon}/>}
             {step.image && <img src={step.image} alt=''/>}
           </div>
           <div className='macKeyboardSetupStepCopy'>
             <div className='macKeyboardSetupStepTitle'>{step.title}</div>
             <div className='macKeyboardSetupStepDetail'>{step.key === 'accessibilityEnabled' && !canRevealApplication
               ? 'Click Allow Access, approve the macOS dialogs, and enable the copy of IntelliKey you are running in Accessibility settings. Enter your Mac password or use Touch ID if asked.'
               : step.detail}</div>
           </div>
           {showAction &&
            <div className='macKeyboardSetupStepActions'>
              <button type='button' className='macKeyboardSetupStepAction' onClick={runAction}>
                {step.actionLabel}
              </button>
              {step.secondaryAction && canRevealApplication && <button type='button' className='macKeyboardSetupStepAction' onClick={() => action(step.secondaryAction)}>
                {step.secondaryActionLabel}
              </button>}
            </div>}
         </div>
}

export const MacKeyboardSettings = ({ status, me }) => {
  const completed = completedMacSetupTaskCount(status)
  const tasks = status && status.tasks ? status.tasks : {}
  const performAction = action => me.performMacSetupAction(action)

  return <div className='macKeyboardSetup'>
           <div className='macKeyboardSetupHeader'>
             <img className='macKeyboardSetupAppIcon' src={IntelliKeyLogo2D} alt='IntelliKey'/>
             <div className='macKeyboardSetupHeading'>Set Up IntelliKey</div>
             <div className='macKeyboardSetupIntro'>
               Complete these steps once. This checklist updates automatically while you use System Settings.
             </div>
             <div className='macKeyboardSetupProgress' role='status'>
               {completed} of {MAC_SETUP_TASK_KEYS.length} complete
             </div>
           </div>
           <div className='macKeyboardSetupSteps'>
             {macSetupSteps.map((step, index) =>
               <MacSetupStep
                 key={step.key}
                 step={step}
                 number={index + 1}
                 complete={tasks[step.key] === true}
                 canRevealApplication={status?.canRevealApplication === true}
                 action={performAction}/>
             )}
           </div>
           <div className='macKeyboardSetupFooter'>
             <div className='macKeyboardSetupNote'>
               After setup, quit and reopen apps that were already running so they load IntelliKey.
             </div>
             <button
               type='button'
               className='macKeyboardSetupRefresh'
               onClick={() => performAction('refresh')}>
               Check Again
             </button>
           </div>
         </div>
}
